import { Archive } from 'lucide-react';
import React from 'react';

import { SoftPill } from './soft-pill';

interface LegacyBadgeProps {
  /** Truthy means the record was imported from the legacy MS SQL DB. */
  legacyId?: number | string | null;
  /** Tooltip override; default explains the badge. */
  tooltip?: string;
}

/**
 * "From legacy" pill - shown on any record whose `legacyId` (or
 * `legacyLookupId`, etc.) is not null. Helps agents distinguish migrated rows
 * from new ones during the cutover window. See cross-stream contract C2 in
 * /Users/shubh/.claude/plans/cozy-weaving-barto.md.
 *
 * Renders nothing if `legacyId` is null/undefined - safe to drop into any
 * cell without conditionals.
 */
export const LegacyBadge = ({
  legacyId,
  tooltip = 'Imported from the legacy MS SQL CRM',
}: LegacyBadgeProps): React.JSX.Element | null => {
  if (legacyId === null || legacyId === undefined) return null;
  return (
    <SoftPill className="border border-zinc-200 bg-zinc-50 text-zinc-600" dot={false}>
      <Archive className="h-3 w-3" aria-hidden />
      <span title={tooltip}>Legacy</span>
    </SoftPill>
  );
};
